/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ProductInputs */

const de__field_product = /** @type {(inputs: _Field_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt`)
};

/**

* @param {_Field_ProductInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_product = /** @type {((inputs?: _Field_ProductInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ProductInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_product(inputs)
});